<script>
import AppBanner from '@/components/shared/AppBanner';
import ProjectsGridCopy from '../components/projects/ProjectsGridCopy.vue';

export default {
	name: 'Home',
	components: { AppBanner, ProjectsGridCopy },
};
</script>

<template>
	<div>
		<!-- Hero -->
		<div class="container mx-auto">
			<AppBanner />
		</div>

		<!-- Divider -->
		<div class="container mx-auto">
			<div class="w-full h-px bg-gradient-to-r from-transparent via-gray-200 dark:via-white/[0.07] to-transparent" />
		</div>

		<!-- Featured projects -->
		<div class="container mx-auto">
			<ProjectsGridCopy />
		</div>

		<!-- View all CTA -->
		<div class="container mx-auto mt-12 mb-4 flex justify-center" data-aos="fade-up" data-aos-delay="200">
			<router-link
				to="/projects"
				class="group inline-flex items-center gap-2 px-7 py-3.5 rounded-lg font-general-medium text-sm
					btn-gradient text-white shadow-lg"
			>
				View All Projects
				<svg class="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1"
					fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
				</svg>
			</router-link>
		</div>
	</div>
</template>
